angular.module('tct.activationService', ['tct.configService'])
  .factory('activationService', activationService);

activationService.$inject = ['configService', '$http'];

function activationService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/activation`;
  const factory = {
    activate,
    sendPassword,
  };

  return factory;

  function activate(token) {
    const url = `${basePath}/${token}`;
    return $http.get(url);
    // return { status: 200 };
  }

  function sendPassword(token, password, passwordConfirmation) {
    const url = `${basePath}/${token}`;
    const data = {
      password,
      password_confirmation: passwordConfirmation,
    };

    const httpconfig = {
      headers: { Accept: 'application/json' },
    };

    const payload = new FormData();
    payload.append('password', password);
    payload.append('password_confirmation', passwordConfirmation);
    return $http.post(url, data, httpconfig);
  }
}
